module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "ix"
    }
  }), _c('a', {
    attrs: {
      "id": "author"
    }
  }), _c('strong', [_vm._v("AUTHOR’S NOTE")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("UNDER STAND RAP is a work of music scholarship that attempts to creatively translate interesting and confusing rap lyrics into language those unfamiliar with rap culture and slang can understand.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("While at times humorous because of the contrast between the artists’ language and the language of the author, the intention of this book is not to poke fun at rap music. Rather, it is to highlight some of the more creative artists and lyrics in the genre today and to bring a basic understanding of concepts and themes in rap music to the attention of an audience who may not otherwise be exposed to these lyrics or give them a second thought. It is not the intention of the author to glorify drug use, violence, crime, or sexual promiscuity, even if such themes or concepts are analyzed in this book. It should also be noted that guests often appear on other artists’ albums and therefore the artist or artists listed beneath a lyric may not be the artist who authored or recited the lyric. Each explanation presented for a lyric in this book represents one of many possible interpretations of these musical works of art, and they are not meant to be taken as fact or to represent the artists’ points of view in any way whatsoever. Any inaccuracies in the lyrics are unintentional. If used or implied, the first person point of view does not necessarily reflect the views of the artist and is used purely for illustrative purposes. Please support all the artists referenced in this book by purchasing and listening to their albums.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53431d69","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/author.vue
// module id = 75
// module chunks = 0